import { Button, CircularProgress, Grid, Typography } from "@mui/material";
import { Form, Formik, FormikHelpers } from "formik";
import { useCallback, useEffect, useState } from "react";
import {
  CandidateDetails,
  JobRequestDetails,
} from "../../../redux/Hire/jobRequestApi";
import { userAccess } from "../../../utils/CommonFunction";

import { useAlert } from "react-alert";
import * as yup from "yup";
import {
  AddAssesmentGuidilineRequest,
  AssessmentAndSubmissionResponse,
  useAddAssessmentGuidelineMutation,
} from "../../../redux/Assessment/assessmentApis";
import FormikInput from "../../../shared/components/FormikInput";
import FormikInputFileUploadWithAzure from "../../../shared/components/FormikInput/FormikInputFileUploadWithAzure";
import FormikUrlInput from "../../../shared/components/FormikInput/FormikUrlInput";

type Props = {
  assessmentDetails?: AssessmentAndSubmissionResponse[];
  candidateDetail: CandidateDetails;
  job: JobRequestDetails;
  stage: string;
};

const validationSchema = yup.object({
  assessmentGuideline: yup.string().required("Guidelines are required"),
});

const AssessmentForm = ({
  job,
  stage,
  assessmentDetails,
  candidateDetail,
}: Props) => {
  const [addAssesment, addAssessmentMutating] =
    useAddAssessmentGuidelineMutation();

  const alert = useAlert();
  const [initailValues, setInitialValues] =
    useState<AddAssesmentGuidilineRequest>({
      assessmentGuideline: assessmentDetails?.[0]?.assessmentGuideline || "",
      attachmentList: assessmentDetails?.[0]?.attachmentList || [],
      urlList: assessmentDetails?.[0]?.urlList || [],
      candidateId: candidateDetail.id.toString(),
      jobId: job.jobId.toString(),
      createdById: userAccess().userId,
      createdByName: userAccess().firstName + " " + userAccess().lastName,
      stage: stage,
      isPassed: false,
    });

  useEffect(() => {
    if (assessmentDetails) {
      setInitialValues((prev) => ({
        ...prev,
        assessmentGuideline: assessmentDetails?.[0]?.assessmentGuideline || "",
        attachmentList: assessmentDetails?.[0]?.attachmentList || [],
        urlList: assessmentDetails?.[0]?.urlList || [],
      }));
    }
  }, [assessmentDetails]);

  const submitForm = useCallback(
    (
      data: AddAssesmentGuidilineRequest,
      formikProps: FormikHelpers<AddAssesmentGuidilineRequest>,
    ) => {
      console.log(data);
      addAssesment(data);
      formikProps.resetForm();
    },
    [addAssesment],
  );

  useEffect(() => {
    if (addAssessmentMutating.isSuccess) {
      alert.success("Assessment added and mail sent to candidate successfully");
    }
    if (addAssessmentMutating.isError) {
      alert.error("Error while sending assessment to candidate");
    }
  }, [addAssessmentMutating, alert]);

  return (
    <Formik
      initialValues={initailValues}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={submitForm}
    >
      {(formikProps) => (
        <Form>
          <Grid container item direction={"column"} my={2} gap={2}>
            <Grid container direction={"column"} gap={1}>
              <Typography
                fontSize={"14px"}
                lineHeight={"20px"}
                fontWeight={"500"}
              >
                Assessment guidelines and rules
              </Typography>
              <FormikInput
                label=""
                name="assessmentGuideline"
                formikProps={formikProps}
                placeholder="Mention coding rules, guidelines and requirements"
                options={undefined}
                multiline
                fullWidth
                rows="5"
              />
            </Grid>
            <Grid container>
              <Grid item xs={2} mt={2}>
                <Typography
                  fontSize={"14px"}
                  lineHeight={"20px"}
                  fontWeight={"500"}
                >
                  Attachments
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <FormikInputFileUploadWithAzure formikProps={formikProps} />
              </Grid>
            </Grid>
            <Grid container>
              <Grid xs={2} mt={2}>
                <Typography
                  fontSize={"14px"}
                  lineHeight={"20px"}
                  fontWeight={"500"}
                >
                  Add URL
                </Typography>
              </Grid>
              <Grid xs={10}>
                <FormikUrlInput formikProps={formikProps} name="urlList" />
              </Grid>
            </Grid>
            <Grid container justifyContent={"flex-end"}>
              <Button
                type="submit"
                variant="contained"
                disabled={addAssessmentMutating.isLoading}
              >
                {addAssessmentMutating.isLoading ? (
                  <CircularProgress size={24} color="primary" />
                ) : (
                  "Submit & send mail to candidate"
                )}
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default AssessmentForm;
